import React from "react";

import { Link } from "react-router-dom";
const ErrorPage = ({ langto }) => {
  return (
    <div
      className={`flex justify-center items-center flex-col gap-8 h-screen ${
        langto === "EN" && "notranslate"
      }`}
    >
      <h3 className=" text-4xl text-center">
        عذرا لم يتم العثور على الصفحة المطلوبة
      </h3>
      <Link to="/">الرجوع لصفحة الإستماع</Link>
    </div>
  );
};

export default ErrorPage;
